import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

import { DropdownOptionModel } from '../../../../../Common/Forms/models/dropdown-option.model';
import { PortfolioCategory } from '../../../enums/portfolio-category.enum';
import { PortfolioRegion } from '../../../enums/portfolio-region.enum';
import { TargetingListService } from '../../../services/targeting-list.service';
import { SortFieldEnum } from '../../../../../Common/TargetingShared/enum/SortField.enum';
import { TargetingList } from '../../../models/targeting-list.model';

@Component({
    selector: 'agpr-portfolio-editor',
    templateUrl: './portfolio-editor.component.html',
    styleUrls: ['./portfolio-editor.component.scss'],
    standalone: false
})
export class PortfolioEditorComponent implements OnInit, OnDestroy {

    @Input() targetingList: TargetingList;

    canSave: boolean = false;

    private subscriptions: Subscription[] = [];

    readonly id = 'portfolioEditor';
    readonly portfolioRegions: DropdownOptionModel<PortfolioRegion>[] = [
        new DropdownOptionModel(`Discover.portfolios.regions.${PortfolioRegion.UNITED_STATES}`,  PortfolioRegion.UNITED_STATES),
        new DropdownOptionModel(`Discover.portfolios.regions.${PortfolioRegion.CANADA}`,         PortfolioRegion.CANADA),
        new DropdownOptionModel(`Discover.portfolios.regions.${PortfolioRegion.UNITED_KINGDOM}`, PortfolioRegion.UNITED_KINGDOM),
        new DropdownOptionModel(`Discover.portfolios.regions.${PortfolioRegion.FRANCE}`,         PortfolioRegion.FRANCE),
    ];
    readonly sortFields: DropdownOptionModel<SortFieldEnum>[] = [
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_UNIQUE_VISITORS,  SortFieldEnum.CIRCULATION_UNIQUE_VISITORS),
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_CIRCULATION,      SortFieldEnum.CIRCULATION_CIRCULATION),
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_FOLLOWERS,        SortFieldEnum.CIRCULATION_FOLLOWERS),
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_LISTENERS,        SortFieldEnum.CIRCULATION_LISTENERS),
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_VIEWERS,          SortFieldEnum.CIRCULATION_VIEWERS),
        new DropdownOptionModel(SortFieldEnum.CIRCULATION_TIER,             SortFieldEnum.CIRCULATION_TIER),
        new DropdownOptionModel(SortFieldEnum.FIRST_NAME,                   SortFieldEnum.FIRST_NAME),
        new DropdownOptionModel(SortFieldEnum.LAST_NAME,                    SortFieldEnum.LAST_NAME),
        new DropdownOptionModel(SortFieldEnum.JOB_TITLE,                    SortFieldEnum.JOB_TITLE),
        new DropdownOptionModel(SortFieldEnum.OUTLET_NAME,                  SortFieldEnum.OUTLET_NAME),
        new DropdownOptionModel(SortFieldEnum.COUNTRY_NAME,                 SortFieldEnum.COUNTRY_NAME),
        new DropdownOptionModel(SortFieldEnum.PROVINCE_NAME,                SortFieldEnum.PROVINCE_NAME),
        new DropdownOptionModel(SortFieldEnum.CITY_NAME,                    SortFieldEnum.CITY_NAME),
        new DropdownOptionModel(SortFieldEnum.JOB_ROLE_IMPORTANCE,          SortFieldEnum.JOB_ROLE_IMPORTANCE),
    ];

    /* eslint-disable max-len */
    readonly portfolioCategories: DropdownOptionModel[] = [
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.NATIONAL_NEWS_MEDIA}`,              PortfolioCategory.NATIONAL_NEWS_MEDIA),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.REGIONAL_NEWS_MEDIA}`,              PortfolioCategory.REGIONAL_NEWS_MEDIA),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.BLACK_MEDIA}`,                      PortfolioCategory.BLACK_MEDIA),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.HISPANIC_MEDIA}`,                   PortfolioCategory.HISPANIC_MEDIA),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.INDIGENOUS_NORTH_AMERICAN_MEDIA}`,  PortfolioCategory.INDIGENOUS_NORTH_AMERICAN_MEDIA),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.ENERGY_AND_ENVIRONMENT}`,           PortfolioCategory.ENERGY_AND_ENVIRONMENT),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.FINANCE}`,                          PortfolioCategory.FINANCE),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.HEALTHCARE}`,                       PortfolioCategory.HEALTHCARE),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.POLITICS}`,                         PortfolioCategory.POLITICS),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.TECHNOLOGY}`,                       PortfolioCategory.TECHNOLOGY),
        new DropdownOptionModel(`Discover.portfolios.categories.${PortfolioCategory.TRAVEL_AND_TOURISM}`,               PortfolioCategory.TRAVEL_AND_TOURISM),
    ];
    /* eslint-enable max-len */


    constructor(
        private targetingListService: TargetingListService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        if (this.targetingList?.portfolioMetadata) {
            this.canSave = true;
        }
    }

    updateCanSave() {
        this.canSave =
            !!this.targetingList.portfolioMetadata.category &&
            !!this.targetingList.portfolioMetadata.region &&
            !!this.targetingList.portfolioMetadata.enGBName &&
            !!this.targetingList.portfolioMetadata.enUSName &&
            !!this.targetingList.portfolioMetadata.frCAName &&
            !!this.targetingList.portfolioMetadata.frFRName;
    }

    savePortfolio() {
        this.targetingListService.updatePortfolio(this.targetingList).subscribe();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
